
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
// import { AuthService } from 'app/core/auth/auth.service';

import { Component, OnInit, Inject, ViewEncapsulation, OnDestroy, ViewChild } from '@angular/core';


import { FuseConfigService } from '@fuse/services/config/config.service';
import { LoginService } from 'app/services/login.service';
import { Login } from '../../../models/login.model';
import { TokenStorageService } from '../../../services/token-storage.service';
import { of, Subscription, Subject } from 'rxjs';
import { catchError, take, switchMap, map, takeUntil } from 'rxjs/operators';

import { UserService } from './../../../services/user.service';
import { format, validate, clean } from '@dgitals/rut';
import { environment } from '../../../../environments/environment';
import { User } from './../../../models/user.model';
// import { RegisterService } from 'app/services/register.service';
import { FuseAlertType } from '@fuse/components/alert';

import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'auth-sign-in',
    templateUrl: './sign-in.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class AuthSignInComponent implements OnInit, OnDestroy {
    @ViewChild('signInNgForm') signInNgForm: NgForm;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    signInForm: FormGroup;
    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: ''
    };
    showAlert: boolean = false;

    user: User;
    pcode = null;
    loginForm: FormGroup;
    passChangeForm: FormGroup;
    loading = false;
    hide = true;
    theme = null;
    passResetFlag = 0;


    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        // private _authService: AuthService,
        private _formBuilder: FormBuilder,
        private _router: Router,
        private route: ActivatedRoute,
        // private _register: RegisterService,
        private _fuseConfigService: FuseConfigService,
        private router: Router,
        // private route: ActivatedRoute,
        private _login: LoginService,
        private tokenStorage: TokenStorageService,
        private _user: UserService,
        @Inject(DOCUMENT) private doc: Document
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // this.pcode = this.route.snapshot.paramMap.get('pcode');

        this.loginForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required],
        });


    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Sign in
     */


    checkAuthentication() {
        // Disable the form
        this.loginForm.disable();
        this.loading = true;
        let data = this.loginForm.value;


        let payload: Login = {
            email: data.email,
            password: data.password,
        }
        this._user.cleanUser();
        this.showAlert = false;

        // mockup navigation -- Eliminar----
        // this.router.navigateByUrl("/home");
        // return
        //--------------

        this._login.logIn(payload).pipe(
            take(1)
        ).subscribe({
            next: (data) => {
                const { accessToken } = data;
                this._user.logIn(accessToken).pipe(take(1)).subscribe(
                    (data) => {
                        // Enable the form
                        this.loginForm.enable();
                        this.loading = false;
                        // this.router.navigateByUrl('change-password');
                    }
                );
            },
            error: (e: any) => {
                //console.log(err);

                switch (e.status) {
                    case 403:
                        this.alert = {
                            type: 'error',
                            message: 'Correo o Contraseña incorrecto(s).'
                        };
                        break;
                    case 429:
                        this.alert = {
                            type: 'error',
                            message: 'Tu cuenta está bloqueada. Comunícate con tu administrador.'
                        };
                        break;
                    default:
                        this.alert = {
                            type: 'error',
                            message: 'No se pudo completar la operación'
                        };
                        break;
                }
                this.showAlert = true;
                this.loginForm.reset();
                // re-Enable the form
                this.loginForm.enable();
                this.loading = false;
            },
            complete: () => {
            }
        });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        // this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
